module.exports = __webpack_public_path__ + "img/kasDel.937def1d.svg";